import {Timeseries} from './timeseries';

export class ChartData {
    id: string;
    timeseries: Timeseries;
}
